import { MOCK_CURRENT_USER } from '../../constants';
import type { ServiceRecord } from '../../types';

// Single edit-permission rule shared by the mutation guard and the UI affordance:
// admins may edit any record, other users only their own, and voided records are
// frozen for everyone (the void trail is the audit record of record).
export const getCanEditRecord = ({
    isAdmin,
    record
}: {
    isAdmin: boolean;
    record: ServiceRecord;
}): boolean => !record.voided && (isAdmin || record.by === MOCK_CURRENT_USER);
